"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _navigationMenu = require("@/api/authorityManagement/navigationMenu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      loading: false,
      activeName: 'superTube',
      queryData: {
        type: 1,
        title: '',
        status: null
      },
      tableData: [],
      // 新增一级目录-------------------
      ControlsType: true,
      // 新增，编辑
      dialogVisible: false,
      ruleForm: {
        isApp: 0,
        // 超管端
        type: 0,
        // 菜单类型[0:目录,1:菜单]
        parentId: 0,
        // 父级id
        id: null,
        sort: null,
        title: '',
        name: '',
        // 组件名称
        status: 0
      },
      rules: {
        title: [{
          required: true,
          message: '目录名称不能为空',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '组件名称不能为空',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '数字不能为空',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '请输入数字值',
          trigger: 'blur'
        }]
      },
      // 下级目录-------------------
      ControlsType1: true,
      dialogVisible1: false,
      ruleForm1: {
        id: null,
        // 修改时
        isApp: 0,
        // 超管端
        parentId: 0,
        // 父级id
        parentIdName: null,
        // 上级name
        title: '',
        // 菜单名称(中文名)
        name: '',
        // 组件名称(英文名)
        sort: null,
        // 排序
        type: 1,
        // 菜单类型[0:目录,1:菜单]
        path: '',
        // 路由地址
        status: 0 // 状态
      },
      rules1: {
        title: [{
          required: true,
          message: '菜单名称不能为空',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '组件名称不能为空',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: '排序不能为空',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '请输入数字值',
          trigger: 'blur'
        }],
        path: [{
          required: true,
          message: '路由地址不能为空',
          trigger: 'blur'
        }, {
          min: 0,
          max: 99,
          message: '长度在 0 到 99 个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.queryMenuTree();
  },
  methods: {
    handleClick: function handleClick(tab) {
      if (tab.index === '0') {
        this.queryData.type = 1;
        this.ruleForm.isApp = 0; // 超管端
        this.ruleForm1.isApp = 0; // 超管端
      } else {
        this.queryData.type = 2;
        this.ruleForm.isApp = 1; // 租户端
        this.ruleForm1.isApp = 1; // 租户端
      }
      this.queryMenuTree();
    },
    onInquire: function onInquire() {
      this.queryMenuTree();
    },
    onInitialize: function onInitialize() {
      this.queryData.title = '';
      this.queryData.status = null;
      this.queryData.id = null;
      this.queryMenuTree();
    },
    // 编辑---------------------------------------
    handleEdit: function handleEdit(row) {
      if (Number(row.parentId) === 0) {
        this.ControlsType = false;
        this.dialogVisible = true;
        this.ruleForm.type = row.type;
        // this.ruleForm.type = 0
        this.ruleForm.id = row.id;
        this.ruleForm.name = row.name;
        this.ruleForm.title = row.title;
        this.ruleForm.sort = row.sort;
        this.ruleForm.status = row.status;
      } else {
        this.ControlsType1 = false;
        this.dialogVisible1 = true;
        this.ruleForm1.id = row.id;
        this.ruleForm1.parentId = row.parentId;
        this.ruleForm1.parentIdName = row.parentTitle;
        this.ruleForm1.title = row.title;
        this.ruleForm1.name = row.name;
        this.ruleForm1.sort = row.sort;
        this.ruleForm1.type = row.type;
        // this.ruleForm1.type = 1
        this.ruleForm1.path = row.path;
        this.ruleForm1.status = row.status;
      }
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this = this;
      console.log(row.id);
      this.$confirm('是否确认删除菜单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.dropPermission(row.id);
      });
    },
    // 一级添加------------------------------------
    onAdd: function onAdd() {
      this.ControlsType = true;
      this.dialogVisible = true;
      this.ruleForm = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.ruleForm), {
        type: 0,
        // 菜单类型[0:目录,1:页面]
        parentId: 0,
        // 父级id
        id: null,
        sort: null,
        title: '',
        name: '',
        // 组件名称
        status: 0
      });
    },
    onClose: function onClose() {
      this.dialogVisible = false;
      this.onInitRuleForm();
    },
    onInitRuleForm: function onInitRuleForm() {
      this.ruleForm.type = 1;
      this.ruleForm.parentId = 0;
      this.ruleForm.sort = null;
      this.ruleForm.title = '';
      this.ruleForm.name = '';
      this.ruleForm.status = 0;
      this.resetForm('ruleForm');
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.saveOrUpdatePermission(_this2.ruleForm);
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      console.log(111111111111111);
      this.ruleForm.type = 0;
      this.ruleForm.parentId = 0;
      this.ruleForm.id = null;
      this.ruleForm.sort = null;
      this.ruleForm.title = '';
      this.ruleForm.name = '';
      this.ruleForm.status = 0;
      this.$refs[formName].resetFields();
    },
    // 二级-----------------------------------
    addSubordinate: function addSubordinate(row) {
      this.ControlsType1 = true;
      this.ruleForm1.id = null;
      this.ruleForm1.parentId = 0;
      this.ruleForm1.parentIdName = null;
      this.ruleForm1.title = '';
      this.ruleForm1.name = '';
      this.ruleForm1.sort = null;
      this.ruleForm1.type = 1;
      this.ruleForm1.path = '';
      this.ruleForm1.status = 0;
      this.dialogVisible1 = true;
      this.ruleForm1.parentId = row.id;
      this.ruleForm1.parentIdName = row.title;
    },
    onInitRuleForm1: function onInitRuleForm1() {
      this.ruleForm1.id = null;
      this.ruleForm1.parentId = 0;
      this.ruleForm1.parentIdName = null;
      this.ruleForm1.title = '';
      this.ruleForm1.name = '';
      this.ruleForm1.sort = null;
      this.ruleForm1.type = 1;
      this.ruleForm1.path = '';
      this.ruleForm1.status = 0;
      this.resetForm1('ruleForm1');
    },
    onClose1: function onClose1() {
      this.dialogVisible1 = false;
      this.onInitRuleForm1();
    },
    submitForm1: function submitForm1(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.saveOrUpdatePermission1(_this3.ruleForm1);
        } else {
          return false;
        }
      });
    },
    resetForm1: function resetForm1(formName) {
      this.ruleForm1.title = '';
      this.ruleForm1.name = '';
      this.ruleForm1.sort = null;
      this.ruleForm1.type = 1;
      this.ruleForm1.path = '';
      this.ruleForm1.status = '';
      this.$refs[formName].resetFields();
    },
    // -----------------------------------
    // 列表
    queryMenuTree: function () {
      var _queryMenuTree2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _navigationMenu.queryMenuTree)(params);
            case 1:
              res = _context.v;
              this.loading = false;
              this.tableData = res.data;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function queryMenuTree() {
        return _queryMenuTree2.apply(this, arguments);
      }
      return queryMenuTree;
    }(),
    // 新增编辑
    saveOrUpdatePermission: function () {
      var _saveOrUpdatePermission2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(data) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, data);
              _context2.n = 1;
              return (0, _navigationMenu.saveOrUpdatePermission)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.onClose();
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.queryMenuTree();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function saveOrUpdatePermission(_x) {
        return _saveOrUpdatePermission2.apply(this, arguments);
      }
      return saveOrUpdatePermission;
    }(),
    // 新增编辑
    saveOrUpdatePermission1: function () {
      var _saveOrUpdatePermission3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(data) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = (0, _objectSpread2.default)({}, data);
              _context3.n = 1;
              return (0, _navigationMenu.saveOrUpdatePermission)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.onClose1();
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.queryMenuTree();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function saveOrUpdatePermission1(_x2) {
        return _saveOrUpdatePermission3.apply(this, arguments);
      }
      return saveOrUpdatePermission1;
    }(),
    // 删除
    dropPermission: function () {
      var _dropPermission2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(permissionId) {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                permissionId: permissionId
              };
              _context4.n = 1;
              return (0, _navigationMenu.dropPermission)(params);
            case 1:
              res = _context4.v;
              console.log('res', res);
              if (res.code === 0) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.queryMenuTree();
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t = _context4.v;
              console.log(_t);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function dropPermission(_x3) {
        return _dropPermission2.apply(this, arguments);
      }
      return dropPermission;
    }()
  }
};